const pages = ['home','about','hiw','stations','curriculum','register','contact','volunteer','outdoor','shop'];

function showPage(id) {
  pages.forEach(p => {
    document.getElementById('page-' + p).classList.remove('active');
    const navEl = document.getElementById('nav-' + p);
    if (navEl) navEl.classList.remove('active');
  });

  document.getElementById('page-' + id).classList.add('active');
  const navEl = document.getElementById('nav-' + id);
  if (navEl) navEl.classList.add('active');

  window.scrollTo({ top: 0, behavior: 'instant' });
}

// Deep-link: open a virtual page from the URL hash on arrival (e.g. /#register from another page)
document.addEventListener('DOMContentLoaded', function () {
  var h = (window.location.hash || '').replace('#', '');
  if (h && pages.indexOf(h) !== -1) showPage(h);
  if (h === 'clay-club-register') showClayForm();
});

function showSkateForm() {
  showPage('register');
  setTimeout(function() {
    var btn = document.getElementById('skate-accordion-btn');
    if (btn && !btn.classList.contains('active')) toggleAccordion(btn);
    if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 50);
}

// Open the Clay Club form on the Register page (used by /#clay-club-register links)
function showClayForm() {
  showPage('register');
  setTimeout(function() {
    var btn = document.getElementById('clay-accordion-btn');
    if (btn && !btn.classList.contains('active')) toggleAccordion(btn);
    if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, 50);
}

// Folder accordion toggle (photo galleries + shop collections)
function wsToggleAccordion(btn) {
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  btn.nextElementSibling.classList.toggle('is-collapsed', expanded);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ws-accordion__toggle').forEach(function (btn) {
    if (btn.getAttribute('aria-expanded') !== 'true') {
      btn.nextElementSibling.classList.add('is-collapsed');
    }
  });
});

// Registration accordion toggle (Forest School / Skate School panels)
function toggleAccordion(btn) {
  var body = btn.nextElementSibling;
  var isOpen = body.classList.contains('open');
  body.classList.toggle('open', !isOpen);
  btn.classList.toggle('active', !isOpen);
}

// Sibling discount — show/hide sibling section, seed first entry
function toggleSiblingFields(checkbox) {
  var container = document.getElementById('sibling_fields');
  if (checkbox.checked) {
    container.style.display = 'block';
    if (document.getElementById('sibling-list').children.length === 0) wsAddSibling();
  } else {
    container.style.display = 'none';
    document.getElementById('sibling-list').innerHTML = '';
  }
}

var WS_AGE_OPTIONS =
  '<option value="">Select age or grade\u2026</option>' +
  '<option>Preschool (Age 3)</option>' +
  '<option>PreK (Age 4)</option>' +
  '<option>Kindergarten (Age 5)</option>' +
  '<option>1st Grade (Age 6)</option>' +
  '<option>2nd Grade (Age 7)</option>' +
  '<option>3rd Grade (Ages 8\u20139)</option>';

// Class cap is 6 students, so one registration is the main child + up to 5 siblings.
var WS_MAX_SIBLINGS = 5;

function wsUpdateSiblingLimit() {
  var list = document.getElementById('sibling-list');
  var btn = document.querySelector('.btn-add-sibling');
  if (!list || !btn) return;
  if (list.children.length >= WS_MAX_SIBLINGS) {
    btn.disabled = true;
    btn.textContent = 'Maximum 6 children per registration';
  } else {
    btn.disabled = false;
    btn.textContent = '+ Add Another Sibling';
  }
}

function wsAddSibling() {
  var list = document.getElementById('sibling-list');
  if (list.children.length >= WS_MAX_SIBLINGS) return;
  var div = document.createElement('div');
  div.className = 'sibling-entry';
  div.innerHTML =
    '<div class="sibling-entry-header">' +
      '<strong class="sibling-label"></strong>' +
      '<button type="button" class="remove-sibling-btn" onclick="wsRemoveSibling(this)">\u2715 Remove</button>' +
    '</div>' +
    '<div class="form-group">' +
      '<label>First Name</label>' +
      '<input type="text" name="sibling_first_name" placeholder="First name">' +
    '</div>' +
    '<div class="form-group">' +
      '<label>Last Name</label>' +
      '<input type="text" name="sibling_last_name" placeholder="Last name">' +
    '</div>' +
    '<div class="form-group">' +
      '<label>Age / Grade</label>' +
      '<select name="sibling_age_grade">' + WS_AGE_OPTIONS + '</select>' +
    '</div>';
  list.appendChild(div);
  wsRenumberSiblings();
  wsUpdateSiblingLimit();
}

function wsRemoveSibling(btn) {
  var entry = btn.closest('.sibling-entry');
  entry.parentNode.removeChild(entry);
  wsRenumberSiblings();
  wsUpdateSiblingLimit();
  if (document.getElementById('sibling-list').children.length === 0) {
    var cb = document.getElementById('sibling_discount_check');
    if (cb) cb.checked = false;
    document.getElementById('sibling_fields').style.display = 'none';
  }
}

function wsRenumberSiblings() {
  document.querySelectorAll('#sibling-list .sibling-entry').forEach(function (entry, i) {
    var lbl = entry.querySelector('.sibling-label');
    if (lbl) lbl.textContent = 'Sibling ' + (i + 1);
  });
}

// ── Disable full workshops in the dropdown ────────────────────
var WS_ROSTER_URL = 'https://script.google.com/macros/s/AKfycbwyp6ZMQFd3Sl_Kh3FiU4YbS0DJA0d-gp02m0_ySNhEAS4izjiE5oWQ37h7itKNCVdSPw/exec';

document.addEventListener('DOMContentLoaded', function () {
  // Both the Art Enrichment and Create & Connect forms use name="workshop"
  var workshopSelects = document.querySelectorAll('[name="workshop"]');
  if (!workshopSelects.length) return;

  fetch(WS_ROSTER_URL + '?t=' + Date.now())
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var full = data.full || [];
      window.WS_FULL = full;
      window.WS_FULL_DAYS = data.fullDays || {};

      workshopSelects.forEach(function (workshopSelect) {
        Array.prototype.forEach.call(workshopSelect.options, function (opt) {
          if (full.indexOf(opt.value) !== -1) {
            opt.disabled = true;
            if (opt.text.indexOf('— FULL') === -1) opt.text = opt.text + ' — FULL';
          }
        });
      });

      // Grey out just the Tuesday/Thursday checkbox when only that session is full
      wsApplyDayLimits();
    })
    .catch(function () { /* silently ignore — form still usable */ });
});

// Disable the Tuesday/Thursday checkboxes for whichever sessions of the
// selected Art Enrichment workshop are full (per WS_FULL_DAYS from the roster).
function wsApplyDayLimits() {
  var form = document.getElementById('forest-reg-form');
  if (!form) return;
  var payMode = (form.querySelector('[name="pay_mode"]:checked') || {}).value || 'dropin';
  if (payMode === 'term') {
    // In term mode a family books every week of the hub, and each week can be
    // full on different days — so clear the per-day disabling; the submit-time
    // check blocks any full session instead.
    form.querySelectorAll('[name="days"]').forEach(function (cb) {
      cb.disabled = false;
      var lbl = cb.closest('label');
      if (lbl) { lbl.style.opacity = ''; var tg = lbl.querySelector('.ws-full-tag'); if (tg) tg.remove(); }
    });
    return;
  }
  var sel = form.querySelector('[name="workshop"]');
  if (!sel) return;
  var fullDays = (window.WS_FULL_DAYS || {})[sel.value] || [];

  form.querySelectorAll('[name="days"]').forEach(function (cb) {
    var isFull = fullDays.indexOf(cb.value) !== -1;
    var label  = cb.closest('label');
    cb.disabled = isFull;
    if (isFull) {
      cb.checked = false;
      if (label && !label.querySelector('.ws-full-tag')) {
        label.style.opacity = '.55';
        var tag = document.createElement('strong');
        tag.className = 'ws-full-tag';
        tag.style.color = '#a33';
        tag.textContent = ' (FULL)';
        label.appendChild(tag);
      }
    } else if (label) {
      label.style.opacity = '';
      var t = label.querySelector('.ws-full-tag');
      if (t) t.remove();
    }
  });
}

// Parse the concept-hub data (label + themed weeks) emitted by the section.
function wsParseHubs() {
  try {
    var el = document.getElementById('aep-hubs-data');
    window.WS_HUBS = el ? JSON.parse(el.textContent) : [];
  } catch (e) { window.WS_HUBS = []; }
}

// True if a concept hub's earliest dated class is before today — the hub has
// already started, so "pay for the full term" should no longer be offered
// (drop-in for the remaining weeks still works). Weeks with no parseable date
// (e.g. "Date TBD") count as future/available.
function wsHubStarted(hub) {
  if (!hub || !hub.weeks) return false;
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var earliest = null;
  hub.weeks.forEach(function (w) {
    var re = /(\d{1,2})\/(\d{1,2})\/(\d{2,4})/g, m;
    while ((m = re.exec(w))) {
      var yr = parseInt(m[3], 10); if (yr < 100) yr += 2000;
      var dt = new Date(yr, parseInt(m[1], 10) - 1, parseInt(m[2], 10));
      if (!isNaN(dt.getTime()) && (earliest === null || dt < earliest)) earliest = dt;
    }
  });
  return earliest !== null && earliest < today;
}

// Fill the "Select Concept Hub (Term)" dropdown from WS_HUBS, honoring the
// optional allowlist (data-term-hubs). Each option shows the hub's week count.
function wsPopulateTermHubs() {
  var form = document.getElementById('forest-reg-form');
  if (!form) return;
  var sel = form.querySelector('[name="term_hub"]');
  if (!sel) return;
  var allow = (form.dataset.termHubs || '').split(/\r?\n/).map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  (window.WS_HUBS || []).forEach(function (h) {
    if (!h.weeks || !h.weeks.length) return;
    if (wsHubStarted(h)) return;  // already-started hub: drop-in only, no term
    if (allow.length) {
      var lbl = (h.label || '').toLowerCase();
      if (!allow.some(function (a) { return lbl.indexOf(a) === 0; })) return;
    }
    var opt = document.createElement('option');
    opt.value = h.label;
    opt.textContent = h.label + ' (' + h.weeks.length + ' week' + (h.weeks.length > 1 ? 's' : '') + ')';
    sel.appendChild(opt);
  });
}

// Show/hide the drop-in vs concept-hub selectors and fix which field is required.
function wsSetPayMode() {
  var form = document.getElementById('forest-reg-form');
  if (!form) return;
  var mode = (form.querySelector('[name="pay_mode"]:checked') || {}).value || 'dropin';
  var dropinGroup = document.getElementById('dropin-workshop-group');
  var termGroup = document.getElementById('term-hub-group');
  var wsSel = form.querySelector('[name="workshop"]');
  var hubSel = form.querySelector('[name="term_hub"]');
  var term = mode === 'term';
  if (dropinGroup) dropinGroup.style.display = term ? 'none' : '';
  if (termGroup)   termGroup.style.display   = term ? '' : 'none';
  if (wsSel)  wsSel.required  = !term;   // avoid "invalid hidden field" on submit
  if (hubSel) hubSel.required = term;
  wsApplyDayLimits();
  wsUpdateTermEstimate();
}

// Live estimate for a concept-hub (term) booking: weeks x days x discounted rate.
function wsUpdateTermEstimate() {
  var form = document.getElementById('forest-reg-form');
  if (!form) return;
  var note = document.getElementById('term-estimate');
  if (!note) return;
  var mode = (form.querySelector('[name="pay_mode"]:checked') || {}).value || 'dropin';
  var hubSel = form.querySelector('[name="term_hub"]');
  var hub = hubSel ? hubSel.value : '';
  var hubObj = (window.WS_HUBS || []).filter(function (h) { return h.label === hub; })[0];
  var weeks = hubObj ? hubObj.weeks.length : 0;
  var days = form.querySelectorAll('[name="days"]:checked').length;
  if (mode !== 'term' || !weeks || !days) { note.style.display = 'none'; return; }
  var sessions = weeks * days;
  var sp = parseFloat((form.dataset.discountStudentPrice || '').replace(/[^0-9.]/g, '')) || 0;
  var sib = parseFloat((form.dataset.discountSiblingPrice || '').replace(/[^0-9.]/g, '')) || 0;
  var html = '<strong>' + weeks + ' week' + (weeks > 1 ? 's' : '') + ' × ' + days + ' day' + (days > 1 ? 's' : '') +
             ' = ' + sessions + ' classes.</strong>';
  if (sp) html += ' Estimated term total for one child: <strong>$' + (sessions * sp).toFixed(0) + '</strong>';
  if (sib) html += ' — each sibling adds $' + (sessions * sib).toFixed(0);
  html += '. You’ll pay in full at checkout.';
  note.innerHTML = html;
  note.style.display = 'block';
}

// ── Forest School Registration ────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {
  var forestForm = document.getElementById('forest-reg-form');
  if (forestForm) forestForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitForestReg(this);
  });

  // Re-evaluate which session days are full whenever the workshop changes
  var forestWorkshopSel = document.querySelector('#forest-reg-form [name="workshop"]');
  if (forestWorkshopSel) forestWorkshopSel.addEventListener('change', wsApplyDayLimits);

  // Concept-hub (term) wiring — only present when the option is enabled
  if (document.querySelector('#forest-reg-form [name="pay_mode"]')) {
    wsParseHubs();
    wsPopulateTermHubs();
    document.querySelectorAll('#forest-reg-form [name="pay_mode"]').forEach(function (r) {
      r.addEventListener('change', wsSetPayMode);
    });
    var termHubSel = document.querySelector('#forest-reg-form [name="term_hub"]');
    if (termHubSel) termHubSel.addEventListener('change', wsUpdateTermEstimate);
    document.querySelectorAll('#forest-reg-form [name="days"]').forEach(function (cb) {
      cb.addEventListener('change', wsUpdateTermEstimate);
    });
    wsSetPayMode(); // set initial visibility/required state
  }

  var skateForm = document.getElementById('skate-reg-form');
  if (skateForm) skateForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitSkateReg(this);
  });

  var volForm = document.getElementById('volunteer-form');
  if (volForm) volForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitVolunteer(this);
  });

  var clayForm = document.getElementById('clay-reg-form');
  if (clayForm) clayForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitClayClub(this);
  });

  var ccForm = document.getElementById('cc-reg-form');
  if (ccForm) ccForm.addEventListener('submit', function (e) {
    e.preventDefault();
    wsSubmitCreateConnect(this);
  });

  // ── Package price display ────────────────────────────────────────
  var SK_BASE_PRICES = { personal: 75, mobile: 95, group: 50 };

  function skUpdatePriceDisplay() {
    var sessionEl = document.getElementById('sk-session-type');
    var packageEl = document.getElementById('sk-package');
    var displayEl = document.getElementById('sk-price-display');
    if (!sessionEl || !packageEl || !displayEl) return;
    var sessionVal = sessionEl.value;
    var pkgVal     = packageEl.value;
    if (!sessionVal || !pkgVal) { displayEl.textContent = ''; return; }
    var base = SK_BASE_PRICES[sessionVal] || 0;
    if (pkgVal === 'sub') {
      displayEl.textContent = '$' + base + ' / week — billed automatically each week, cancel anytime';
    } else {
      var numSessions = parseInt(pkgVal, 10);
      var total = base * numSessions;
      var label = numSessions === 1 ? 'Single session' : numSessions + ' sessions';
      displayEl.textContent = label + ' — $' + total + (numSessions > 1 ? ' total (paid upfront)' : '');
    }
  }

  var skSessionEl = document.getElementById('sk-session-type');
  var skPackageEl = document.getElementById('sk-package');
  if (skSessionEl) skSessionEl.addEventListener('change', skUpdatePriceDisplay);
  if (skPackageEl) skPackageEl.addEventListener('change', function () {
    skUpdatePriceDisplay();
    // Re-trigger date hint if a date is already selected
    var iso = document.getElementById('skate_date_iso') ? document.getElementById('skate_date_iso').value : '';
    if (iso) {
      var friendly = document.getElementById('skate_date').value;
      var pkgVal2  = this.value;
      var numPkg   = pkgVal2 === 'sub' ? 4 : parseInt(pkgVal2, 10);
      var isSub    = pkgVal2 === 'sub';
      if (numPkg > 1) {
        var hintDates = [friendly];
        for (var wi = 1; wi < numPkg; wi++) hintDates.push(skIsoToFriendly(skAddDays(iso, wi * 7)));
        var hintLabel = isSub ? 'Booking first month (' + numPkg + ' sessions): ' : 'Booking ' + numPkg + ' sessions: ';
        document.getElementById('sk-date-hint').textContent = hintLabel + hintDates.join(' \u00b7 ');
      } else {
        document.getElementById('sk-date-hint').textContent = 'Selected: ' + friendly;
      }
    }
  });

  // ── Skate School Availability Calendar ──────────────────────────
  var SK_MONTHS  = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var SK_DOW     = ['Su','Mo','Tu','We','Th','Fr','Sa'];
  var SK_DAYNAME = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  var skCal = { year: 0, month: 0, bookedIso: [], selectedIso: null };

  // ── Pure-math date helpers — no Date API, no timezone bugs ──────
  // Day of week via Tomohiko Sakamoto's algorithm (0=Sun … 6=Sat)
  function skDayOfWeek(year, month, day) {
    var t = [0, 3, 2, 5, 0, 3, 5, 1, 4, 6, 2, 4];
    var m = month + 1; // convert to 1-indexed
    if (m < 3) year -= 1;
    return (year + Math.floor(year / 4) - Math.floor(year / 100) + Math.floor(year / 400) + t[m - 1] + day) % 7;
  }
  function skDaysInMonth(year, month) {
    var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 1 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0)) return 29;
    return days[month];
  }
  function skPad(n) { return n < 10 ? '0' + n : '' + n; }
  function skISO(year, month, day) { return year + '-' + skPad(month + 1) + '-' + skPad(day); }
  function skTodayISO() {
    var n = new Date();
    return skISO(n.getFullYear(), n.getMonth(), n.getDate());
  }

  function skCalRender() {
    var el = document.getElementById('sk-cal');
    if (!el) return;

    var todayISO       = skTodayISO();
    var startDow       = skDayOfWeek(skCal.year, skCal.month, 1);
    var daysInMonth    = skDaysInMonth(skCal.year, skCal.month);
    var isCurrentMonth = skISO(skCal.year, skCal.month, 1).slice(0, 7) === todayISO.slice(0, 7);

    var h = '<div class="sk-cal-head">';
    h += '<button type="button" class="sk-cal-nav" id="sk-prev"' + (isCurrentMonth ? ' disabled' : '') + '>&#8249;</button>';
    h += '<span>' + SK_MONTHS[skCal.month] + ' ' + skCal.year + '</span>';
    h += '<button type="button" class="sk-cal-nav" id="sk-next">&#8250;</button>';
    h += '</div><div class="sk-cal-grid">';

    SK_DOW.forEach(function(d) { h += '<div class="sk-cal-dow">' + d + '</div>'; });

    for (var i = 0; i < startDow; i++) h += '<div class="sk-cal-cell">\u00a0</div>';

    for (var day = 1; day <= daysInMonth; day++) {
      var iso       = skISO(skCal.year, skCal.month, day);
      var dow       = skDayOfWeek(skCal.year, skCal.month, day);
      var isWeekday = dow >= 1 && dow <= 5;
      var isPast    = iso < todayISO;
      var isBooked  = skCal.bookedIso.indexOf(iso) !== -1;
      var isSel     = skCal.selectedIso === iso;

      var cls = 'sk-cal-cell';
      var attr = '';

      if (isWeekday) {
        cls += ' sk-target';
        if (isPast)        { cls += ' sk-past'; }
        else if (isSel)    { cls += ' sk-selected'; attr = ' data-iso="' + iso + '"'; }
        else if (isBooked) { cls += ' sk-booked'; }
        else               { cls += ' sk-available'; attr = ' data-iso="' + iso + '"'; }
      }

      h += '<div class="' + cls + '"' + attr + '>' + day + '</div>';
    }

    var total = startDow + daysInMonth;
    var trail = (7 - (total % 7)) % 7;
    for (var j = 0; j < trail; j++) h += '<div class="sk-cal-cell">\u00a0</div>';

    h += '</div>';
    h += '<div class="sk-cal-legend">';
    h += '<div class="sk-cal-legend-item"><div class="sk-cal-legend-dot" style="background:#2d6a3f;border-radius:3px">\u00a0</div>Available</div>';
    h += '<div class="sk-cal-legend-item"><div class="sk-cal-legend-dot" style="background:#842029;border-radius:3px">\u00a0</div>Booked</div>';
    h += '</div>';

    el.innerHTML = h;

    var prevBtn = document.getElementById('sk-prev');
    var nextBtn = document.getElementById('sk-next');
    if (prevBtn && !prevBtn.disabled) prevBtn.addEventListener('click', function() {
      skCal.month--; if (skCal.month < 0) { skCal.month = 11; skCal.year--; } skCalRender();
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      skCal.month++; if (skCal.month > 11) { skCal.month = 0; skCal.year++; } skCalRender();
    });

    el.querySelectorAll('[data-iso]').forEach(function(cell) {
      cell.addEventListener('click', function() {
        var iso      = this.getAttribute('data-iso');
        // Parse as UTC noon so toLocaleDateString gives correct local date
        var parts    = iso.split('-');
        var d        = new Date(Date.UTC(+parts[0], +parts[1] - 1, +parts[2], 12));
        var dayName  = SK_DAYNAME[d.getUTCDay()];
        var friendly = d.toLocaleDateString('en-US', { weekday:'long', month:'long', day:'numeric', year:'numeric', timeZone:'UTC' });
        skCal.selectedIso = iso;
        document.getElementById('skate_day').value      = dayName;
        document.getElementById('skate_date').value     = friendly;
        document.getElementById('skate_date_iso').value = iso;
        // Show all package dates in the hint
        var pkgEl   = document.getElementById('sk-package');
        var pkgVal3 = pkgEl ? pkgEl.value : '1';
        var isSub3  = pkgVal3 === 'sub';
        var numPkg  = isSub3 ? 4 : parseInt(pkgVal3, 10);
        if (numPkg > 1) {
          var hintDates = [friendly];
          for (var wi = 1; wi < numPkg; wi++) hintDates.push(skIsoToFriendly(skAddDays(iso, wi * 7)));
          var hintLabel = isSub3 ? 'Booking first month (' + numPkg + ' sessions): ' : 'Booking ' + numPkg + ' sessions: ';
          document.getElementById('sk-date-hint').textContent = hintLabel + hintDates.join(' \u00b7 ');
        } else {
          document.getElementById('sk-date-hint').textContent = 'Selected: ' + friendly;
        }
        skCalRender();
      });
    });
  }

  // Init calendar immediately on page load
  if (skateForm) {
    var now = new Date();
    skCal.year  = now.getFullYear();
    skCal.month = now.getMonth();
    var calEl   = document.getElementById('sk-cal');
    if (calEl) calEl.innerHTML = '<div style="padding:1.5rem;text-align:center;color:var(--text-muted);font-size:.9rem">Loading availability\u2026</div>';
    var availUrl = skateForm.dataset.availabilityUrl;
    if (availUrl) {
      fetch(availUrl, { method: 'GET' })
        .then(function(r) { return r.json(); })
        .then(function(data) { skCal.bookedIso = data.bookedDates || []; skCalRender(); })
        .catch(function() { skCal.bookedIso = []; skCalRender(); });
    } else {
      skCalRender();
    }
  }
});

function wsSubmitForestReg(form) {
  var btn = document.getElementById('fs-submit');
  var errEl = document.getElementById('fs-error');
  errEl.style.display = 'none';

  var studentVariant = form.dataset.studentVariant;
  var siblingVariant = form.dataset.siblingVariant;
  if (!studentVariant) {
    errEl.textContent = 'Checkout is not yet configured. Please contact us directly to register.';
    errEl.style.display = 'block';
    return;
  }

  // Collect checked days
  var days = [];
  form.querySelectorAll('[name="days"]:checked').forEach(function (cb) { days.push(cb.value); });

  var properties = {
    'Child Name': form.querySelector('[name="child_first_name"]').value + ' ' + form.querySelector('[name="child_last_name"]').value,
    'Age / Grade': form.querySelector('[name="age_grade"]').value,
    'Workshop': form.querySelector('[name="workshop"]').value,
    'Parent / Guardian': form.querySelector('[name="parent_name"]').value,
    'Email': form.querySelector('[name="email"]').value,
    'Phone': form.querySelector('[name="phone"]').value
  };

  var allergies = form.querySelector('[name="allergies_special_needs"]').value;
  if (allergies) properties['Allergies / Special Needs'] = allergies;

  var referral = form.querySelector('[name="referral"]').value;
  if (referral) properties['How they heard about us'] = referral;

  var notes = form.querySelector('[name="additional_notes"]').value;
  if (notes) properties['Notes'] = notes;

  // Collect all sibling entries
  var siblings = [];
  document.querySelectorAll('#sibling-list .sibling-entry').forEach(function (entry) {
    var first = entry.querySelector('[name="sibling_first_name"]').value.trim();
    var last  = entry.querySelector('[name="sibling_last_name"]').value.trim();
    var grade = entry.querySelector('[name="sibling_age_grade"]').value;
    var name  = (first + ' ' + last).trim();
    if (name) siblings.push(name + (grade ? ' \u2014 ' + grade : ''));
  });
  if (siblings.length > WS_MAX_SIBLINGS) {
    errEl.textContent = 'A single registration can include at most 6 children (the main child plus 5 siblings). Please submit an additional registration for more.';
    errEl.style.display = 'block';
    return;
  }
  siblings.forEach(function (sib, i) {
    properties['Sibling ' + (i + 1)] = sib;
  });

  var studentVariant2nd = form.dataset.studentVariant2nd || studentVariant;
  var siblingVariant2nd = form.dataset.siblingVariant2nd || siblingVariant;
  var payMode = (form.querySelector('[name="pay_mode"]:checked') || {}).value || 'dropin';
  var items = [];

  if (payMode === 'term') {
    // ── Pay for the concept hub (term) ──────────────────────────────
    // Every themed week of the chosen hub, on the chosen day(s), at the
    // discounted rate. One student line item per session so the roster logs
    // one enrollment row per class (and per-session capacity stays correct).
    if (!form.dataset.studentVariant2nd) {
      errEl.textContent = 'Concept-hub checkout is not configured yet. Please choose Drop-in, or contact us to register for the term.';
      errEl.style.display = 'block';
      return;
    }
    var hubSel = form.querySelector('[name="term_hub"]');
    var hub = hubSel ? hubSel.value : '';
    if (!hub) {
      errEl.textContent = 'Please choose a concept hub (term).';
      errEl.style.display = 'block';
      return;
    }
    if (days.length === 0) {
      errEl.textContent = 'Please choose at least one day — Tuesday, Thursday, or both.';
      errEl.style.display = 'block';
      return;
    }
    var hubObj = (window.WS_HUBS || []).filter(function (h) { return h.label === hub; })[0];
    var weeks = hubObj ? hubObj.weeks : [];
    if (!weeks.length) {
      errEl.textContent = 'That concept hub has no classes set up yet. Please contact us to register.';
      errEl.style.display = 'block';
      return;
    }
    if (wsHubStarted(hubObj)) {
      errEl.textContent = 'This concept hub has already started, so it can no longer be booked as a full term. Please register drop-in for the remaining classes, or contact us.';
      errEl.style.display = 'block';
      return;
    }

    // Block if any session in the term is already full
    var fullAll = window.WS_FULL || [];
    var fullDaysMap = window.WS_FULL_DAYS || {};
    var fullHits = [];
    weeks.forEach(function (week) {
      days.forEach(function (day) {
        if (fullAll.indexOf(week) !== -1 || (fullDaysMap[week] || []).indexOf(day) !== -1) {
          fullHits.push(week + ' (' + day + ')');
        }
      });
    });
    if (fullHits.length) {
      errEl.innerHTML = 'Some classes in this concept hub are already full: ' + fullHits.join('; ') +
        '. Please email <a href="mailto:jh@allinonecrafts.com">jh@allinonecrafts.com</a> to join the waitlist or pick another option.';
      errEl.style.display = 'block';
      return;
    }

    var sessionCount = 0;
    weeks.forEach(function (week) {
      days.forEach(function (day) {
        var wkProps = Object.assign({}, properties, {
          'Workshop': week,
          'Preferred Days': day,
          'Registration Type': 'Concept Hub (Term)',
          'Concept Hub': hub
        });
        items.push({ id: parseInt(studentVariant2nd, 10), quantity: 1, properties: wkProps });
        sessionCount++;
      });
    });
    if (siblings.length > 0 && siblingVariant2nd) {
      siblings.forEach(function () {
        items.push({ id: parseInt(siblingVariant2nd, 10), quantity: sessionCount });
      });
    }

  } else {
    // ── Drop-in: charge per selected day — both days = two line items ──
    // 2nd-day discount: booking BOTH days together bills the added Thursday at
    // the discounted variant (Tuesday stays full; Thursday-only stays full).
    var bothDays = days.indexOf('Tuesday') !== -1 && days.indexOf('Thursday') !== -1;
    var studentVariantForDay = function (day) {
      return (bothDays && day === 'Thursday') ? studentVariant2nd : studentVariant;
    };
    var siblingVariantForDay = function (day) {
      return (bothDays && day === 'Thursday') ? siblingVariant2nd : siblingVariant;
    };

    var daysToCharge = days.length >= 2 ? days : [days[0] || 'Not specified'];
    daysToCharge.forEach(function (day) {
      var dayProps = Object.assign({}, properties, { 'Preferred Days': day });
      items.push({ id: parseInt(studentVariantForDay(day), 10), quantity: 1, properties: dayProps });
    });
    if (siblings.length > 0 && siblingVariant) {
      siblings.forEach(function () {
        daysToCharge.forEach(function (day) {
          items.push({ id: parseInt(siblingVariantForDay(day), 10), quantity: 1 });
        });
      });
    }
  }

  btn.disabled = true;
  btn.textContent = 'Adding to cart\u2026';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'] })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Submit Workshop Registration \u2192';
      if (data.status) {
        errEl.textContent = data.description || 'Something went wrong. Please try again.';
        errEl.style.display = 'block';
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.location.href = '/cart';
      }
      form.reset();
      document.getElementById('sibling_fields').style.display = 'none';
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Submit Workshop Registration \u2192';
      errEl.textContent = 'Network error. Please try again.';
      errEl.style.display = 'block';
    });
}

// ── Skate date helpers (global so wsSubmitSkateReg can use them) ─
function skAddDays(iso, days) {
  var d = new Date(iso + 'T12:00:00Z');
  d.setUTCDate(d.getUTCDate() + days);
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
  return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
}
function skIsoToFriendly(iso) {
  var DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var d = new Date(iso + 'T12:00:00Z');
  return DAYS[d.getUTCDay()] + ', ' + MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
}

// ── Skate School Registration ────────────────────────────────

function wsSubmitSkateReg(form) {
  var btn = document.getElementById('sk-submit');
  var errEl = document.getElementById('sk-error');
  errEl.style.display = 'none';

  var sessionSelect = document.getElementById('sk-session-type');
  var sessionVal = sessionSelect ? sessionSelect.value : '';

  if (!sessionVal) {
    errEl.textContent = 'Please select a session type.';
    errEl.style.display = 'block';
    return;
  }

  var packageSelect  = document.getElementById('sk-package');
  var pkgVal         = packageSelect ? packageSelect.value : '1';
  var isSubscription = pkgVal === 'sub';
  var numSessions    = isSubscription ? 4 : parseInt(pkgVal, 10);

  var skateDateIsoCheck = form.querySelector('[name="skate_date_iso"]') ? form.querySelector('[name="skate_date_iso"]').value : '';
  if (!skateDateIsoCheck) {
    errEl.textContent = 'Please select a session date from the calendar.';
    errEl.style.display = 'block';
    return;
  }

  // Subscriptions use the single-session variant + a selling_plan ID
  var variantId;
  if (isSubscription) {
    var subVariantMap = { personal: form.dataset.personalVariant, mobile: form.dataset.mobileVariant, group: form.dataset.groupVariant };
    variantId = subVariantMap[sessionVal];
  } else {
    var variantMap = {
      'personal-1': form.dataset.personalVariant,
      'personal-2': form.getAttribute('data-personal-2wk-variant'),
      'personal-4': form.getAttribute('data-personal-4wk-variant'),
      'personal-8': form.getAttribute('data-personal-8wk-variant'),
      'mobile-1':   form.dataset.mobileVariant,
      'mobile-2':   form.getAttribute('data-mobile-2wk-variant'),
      'mobile-4':   form.getAttribute('data-mobile-4wk-variant'),
      'mobile-8':   form.getAttribute('data-mobile-8wk-variant'),
      'group-1':    form.dataset.groupVariant,
      'group-2':    form.getAttribute('data-group-2wk-variant'),
      'group-4':    form.getAttribute('data-group-4wk-variant'),
      'group-8':    form.getAttribute('data-group-8wk-variant')
    };
    variantId = variantMap[sessionVal + '-' + pkgVal];
  }

  if (!variantId) {
    errEl.textContent = 'Checkout is not yet configured. Please contact us directly to register.';
    errEl.style.display = 'block';
    return;
  }

  var sellingPlanId = form.dataset.sellingPlan || '';
  if (isSubscription && !sellingPlanId) {
    errEl.textContent = 'Subscription is not yet configured. Please contact us directly to register.';
    errEl.style.display = 'block';
    return;
  }

  var skateDay     = form.querySelector('[name="skate_day"]').value;
  var skateDate    = form.querySelector('[name="skate_date"]').value;
  var skateDateIso = form.querySelector('[name="skate_date_iso"]').value;

  var sessionLabel = sessionSelect.options[sessionSelect.selectedIndex].text;
  var packageLabel = isSubscription ? 'Weekly Subscription' : (numSessions === 1 ? 'Single Session' : numSessions + ' Weeks');

  var properties = {
    'Student Name':       form.querySelector('[name="skate_first_name"]').value + ' ' + form.querySelector('[name="skate_last_name"]').value,
    'Age':                form.querySelector('[name="skate_age"]').value,
    'Session Type':       sessionLabel,
    'Package':            packageLabel,
    'Number of Sessions': isSubscription ? 'Weekly (ongoing)' : String(numSessions),
    'Preferred Day':      skateDay || 'Not specified',
    'Session Date':       skateDate || 'Not specified',
    'Parent / Guardian':  form.querySelector('[name="skate_parent_name"]').value,
    'Email':              form.querySelector('[name="skate_email"]').value,
    'Phone':              form.querySelector('[name="skate_phone"]').value
  };

  var skateNotes = form.querySelector('[name="skate_notes"]').value;
  if (skateNotes) properties['Notes'] = skateNotes;

  btn.disabled = true;
  btn.textContent = 'Adding to cart\u2026';

  var cartItem = { id: parseInt(variantId, 10), quantity: 1, properties: properties };
  if (isSubscription) cartItem.selling_plan = parseInt(sellingPlanId, 10);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [cartItem], sections: ['cart-drawer', 'cart-icon-bubble'] })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      btn.disabled = false;
      btn.textContent = 'Submit Skate School Registration \u2192';
      if (data.status) {
        errEl.textContent = data.description || 'Something went wrong. Please try again.';
        errEl.style.display = 'block';
        return;
      }
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        window.location.href = '/cart';
      }
      form.reset();
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Submit Skate School Registration \u2192';
      errEl.textContent = 'Network error. Please try again.';
      errEl.style.display = 'block';
    });
}

// Volunteer form -> Google Apps Script (writes a row to the Volunteers sheet)
function wsSubmitVolunteer(form) {
  var btn = document.getElementById('vol-submit');
  var errEl = document.getElementById('vol-error');
  var okEl = document.getElementById('vol-success');
  errEl.style.display = 'none';

  var url = (form.dataset.endpoint || '').trim();
  if (!url) {
    errEl.textContent = 'The volunteer form is not connected yet. Please email us at jh@allinonecrafts.com and we will get you set up.';
    errEl.style.display = 'block';
    return;
  }

  var email = (form.querySelector('[name="email"]').value || '').trim();
  if (!email) {
    errEl.textContent = 'Please enter your email so we can reach you.';
    errEl.style.display = 'block';
    return;
  }

  var fd = new FormData(form);
  // Fold the multi-checkbox groups into single comma-separated fields
  ['availability', 'interests'].forEach(function (key) {
    var vals = [];
    form.querySelectorAll('[name="' + key + '"]:checked').forEach(function (cb) { vals.push(cb.value); });
    fd.delete(key);
    fd.append(key, vals.join(', '));
  });

  btn.disabled = true;
  btn.textContent = 'Sending\u2026';

  fetch(url, { method: 'POST', body: fd, mode: 'no-cors' })
    .then(function () {
      form.style.display = 'none';
      okEl.style.display = 'block';
      okEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Submit \u2192';
      errEl.textContent = 'Something went wrong sending your info. Please try again, or email us at jh@allinonecrafts.com.';
      errEl.style.display = 'block';
    });
}

// Create & Connect registration -> Google Apps Script (writes a row to the sheet)
function wsSubmitCreateConnect(form) {
  var btn = document.getElementById('cc-submit');
  var errEl = document.getElementById('cc-error');
  var okEl = document.getElementById('cc-success');
  errEl.style.display = 'none';

  var sel = form.querySelector('[name="workshop"]');
  if (!sel.value) {
    errEl.textContent = 'Please choose a workshop.';
    errEl.style.display = 'block';
    return;
  }
  if (!form.querySelector('[name="waiver_agreed"]').checked) {
    errEl.textContent = 'Please read and agree to the liability waiver to continue.';
    errEl.style.display = 'block';
    return;
  }

  var opt = sel.options[sel.selectedIndex];
  var variantId = (opt.getAttribute('data-variant') || '').trim();
  var spots = parseInt(form.querySelector('[name="spots"]').value, 10) || 1;
  if (spots > 10) spots = 10;
  if (spots < 1) spots = 1;
  var sheetUrl = (form.dataset.endpoint || '').trim();

  // Always log the sign-up to the sheet (fire-and-forget) if connected
  if (sheetUrl) {
    try { fetch(sheetUrl, { method: 'POST', body: new FormData(form), mode: 'no-cors' }); } catch (e) {}
  }

  // If this workshop is priced (has a variant), send them to checkout
  if (variantId) {
    var props = {
      'Workshop': sel.value,
      'Name': form.querySelector('[name="first_name"]').value + ' ' + form.querySelector('[name="last_name"]').value,
      'Email': form.querySelector('[name="email"]').value,
      'Phone': form.querySelector('[name="phone"]').value,
      'Spots': String(spots),
      'Who is attending': form.querySelector('[name="attendees"]').value,
      'Notes': form.querySelector('[name="notes"]').value,
      'Waiver agreed': 'Yes'
    };
    btn.disabled = true;
    btn.textContent = 'Starting checkout\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: spots, properties: props }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) {
          btn.disabled = false;
          btn.textContent = 'Submit Registration \u2192';
          errEl.textContent = data.description || 'Could not start checkout. Please try again, or email us at jh@allinonecrafts.com.';
          errEl.style.display = 'block';
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Submit Registration \u2192';
        errEl.textContent = 'Could not start checkout. Please try again, or email us at jh@allinonecrafts.com.';
        errEl.style.display = 'block';
      });
    return;
  }

  // No price/variant on this workshop -> just collected to the sheet
  if (!sheetUrl) {
    errEl.textContent = 'This form is not connected yet. Please email us at jh@allinonecrafts.com to register.';
    errEl.style.display = 'block';
    return;
  }
  form.style.display = 'none';
  okEl.style.display = 'block';
  okEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// ── Clay Club registration ─────────────────────────────────────
// Sign-up only (no checkout): POSTs the form to the Clay Club Apps Script, which
// saves a row to the Clay Club tab and emails the confirmation.
function wsSubmitClayClub(form) {
  var btn   = document.getElementById('clay-submit');
  var errEl = document.getElementById('clay-error');
  var okEl  = document.getElementById('clay-success');
  errEl.style.display = 'none';

  function fail(msg) {
    errEl.textContent = msg;
    errEl.style.display = 'block';
    btn.disabled = false;
    btn.textContent = 'Submit Clay Club Registration \u2192';
  }

  if (!form.querySelector('[name="waiver_agreed"]').checked) {
    return fail('Please read and agree to the liability waiver to continue.');
  }
  var url = (form.dataset.endpoint || '').trim();
  if (!url) {
    return fail('This form is not connected yet. Please email us at jh@allinonecrafts.com to register.');
  }

  btn.disabled = true;
  btn.textContent = 'Submitting\u2026';

  fetch(url, { method: 'POST', body: new FormData(form), mode: 'no-cors' })
    .then(function () {
      form.style.display = 'none';
      okEl.style.display = 'block';
      okEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    })
    .catch(function () {
      fail('Something went wrong. Please try again, or email us at jh@allinonecrafts.com.');
    });
}
